export default __webpack_public_path__ + "static/media/keto_veggies.e4b04a1b.jpg";